// --- DEBUGGING VERSION ---
document.addEventListener('DOMContentLoaded', function() {
  console.log('Retail Price Script: Initialized and running.');

  const detailsContainer = document.querySelector('.product-custom-details[data-retail-prices]');
  if (!detailsContainer) {
    console.error('Retail Price Script: CRITICAL - Could not find the container div with class "product-custom-details".');
    return;
  }
  console.log('Retail Price Script: Found the container div.');

  function updateRetailPrice(currencyCode) {
    console.log('--- Running updateRetailPrice ---');
    console.log('Retail Price Script: Attempting to update for currency code:', currencyCode);

    const displayElement = detailsContainer.querySelector('[data-retail-price-display]');
    if (!displayElement) {
      console.error('Retail Price Script: CRITICAL - Could not find the price display span.');
      return;
    }

    const pricesDataString = detailsContainer.dataset.retailPrices;
    console.log('Retail Price Script: Raw price data from HTML is:', pricesDataString);

    if (!pricesDataString || pricesDataString.trim() === '') {
      console.warn('Retail Price Script: Price data is empty. Hiding price.');
      displayElement.parentElement.style.display = 'none';
      return;
    }

    try {
      const pricesData = JSON.parse(pricesDataString);
      console.log('Retail Price Script: Successfully parsed JSON data:', pricesData);

      const defaultCurrency = detailsContainer.dataset.defaultCurrency;
      console.log('Retail Price Script: Default currency is:', defaultCurrency);

      let priceFound = false;

      // Check for current currency - CASE-INSENSITIVE CHECK
      for (const key in pricesData) {
        if (key.toUpperCase() === currencyCode.toUpperCase()) {
          console.log('Retail Price Script: SUCCESS - Found a match for current currency:', key);
          let priceInCents = pricesData[key] * 100;
          const safeMoneyFormat = '${{amount}}';
          const moneyFormat = window.Shopify.theme.moneyFormat || safeMoneyFormat;
          displayElement.textContent = Shopify.formatMoney(priceInCents, moneyFormat);
          displayElement.parentElement.style.display = '';
          priceFound = true;
          break; // Exit loop once found
        }
      }

      // If no match, check for default currency - CASE-INSENSITIVE CHECK
      if (!priceFound) {
        console.log('Retail Price Script: No match for current currency. Checking for default...');
        for (const key in pricesData) {
          if (key.toUpperCase() === defaultCurrency.toUpperCase()) {
            console.log('Retail Price Script: SUCCESS - Found a match for default currency:', key);
            let priceInCents = pricesData[key] * 100;
            const safeMoneyFormat = '${{amount}}';
            const moneyFormat = window.Shopify.theme.moneyFormat || safeMoneyFormat;
            displayElement.textContent = Shopify.formatMoney(priceInCents, moneyFormat);
            displayElement.parentElement.style.display = '';
            priceFound = true;
            break; // Exit loop once found
          }
        }
      }

      if (!priceFound) {
        console.error('Retail Price Script: CRITICAL - No match found for current OR default currency. Hiding price.');
        displayElement.parentElement.style.display = 'none';
      }

    } catch (e) {
      console.error("Retail Price Script: CRITICAL - Error parsing the JSON data. Is it formatted correctly in the metafield?", e);
      displayElement.parentElement.style.display = 'none';
    }
  }

  function initializePrice() {
    if (window.Shopify && window.Shopify.currency && window.Shopifiy.currency.active) {
      updateRetailPrice(window.Shopify.currency.active);
    } else {
      setTimeout(initializePrice, 100);
    }
  }
  
  // Listen for Shopify's events
  document.addEventListener('cart:updated', (event) => updateRetailPrice(event.detail.cart.currency.iso_code));
  document.addEventListener('localization:change', (event) => updateRetailPrice(event.detail.currency.iso_code));
  
  // Start the initialization
  initializePrice();
});